import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import Header from "./component/Header.jsx";
import Footer from "./component/Footer.jsx";
import "./style.css";
import CountUp, { useCountUp } from "react-countup";
import SkillBar from "./component/SkillBar";
import {
  slides,
  slidesBrand,
  slidesTeam,
  slidesTestimonail,
} from "./utilities/constant";
import { Link } from "react-router-dom";
import { useDemo } from "./context/DemoContext.jsx";
import Testimonial from "./component/Testimonial.jsx";

export default function Home() {
  const { setDemoValue } = useDemo();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
  const countUpRef = useRef(null);
  useCountUp({
    ref: countUpRef,
    end: 80,
    duration: 2.5,
  });

  return (
    <div>
      <Header />
      {/* <!-- Header End --> */}

      {/* <!-- Hero Start --> */}
      <div
        className="section techwix-hero-section-03 d-flex align-items-center heroSectionImage"
        style={{ backgroundImage: "url(/images/hero-bg3.jpeg)" }}
      >
        <div className="shape-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="944px" height="894px">
            <defs>
              <linearGradient
                id="PSgrad_0"
                x1="88.295%"
                x2="0%"
                y1="0%"
                y2="46.947%"
              >
                <stop offset="0%" stopColor="rgb(67,186,255)" stopOpacity="1" />
                <stop
                  offset="100%"
                  stopColor="rgb(113,65,177)"
                  stopOpacity="1"
                />
              </linearGradient>
            </defs>
            <path
              fillRule="evenodd"
              fill="rgb(43, 142, 254)"
              d="M39.612,410.76 L467.344,29.823 C516.51,-13.476 590.638,-9.94 633.939,39.612 L914.192,317.344 C957.492,366.50 953.109,440.638 904.402,483.939 L476.671,864.191 C427.964,907.492 353.376,903.109 310.76,854.402 L29.823,576.670 C-13.477,527.963 -9.94,453.376 39.612,410.76 Z"
            />
            <path
              fill="url(#PSgrad_0)"
              d="M39.612,410.76 L467.344,29.823 C516.51,-13.476 590.638,-9.94 633.939,39.612 L914.192,317.344 C957.492,366.50 953.109,440.638 904.402,483.939 L476.671,864.191 C427.964,907.492 353.376,903.109 310.76,854.402 L29.823,576.670 C-13.477,527.963 -9.94,453.376 39.612,410.76 Z"
            />
          </svg>
        </div>
        <div className="shape-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="726.5px"
            height="726.5px"
          >
            <path
              fillRule="evenodd"
              stroke="rgb(255, 255, 255)"
              strokeWidth="1px"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              opacity="0.302"
              fill="none"
              d="M28.14,285.269 L325.37,21.216 C358.860,-8.852 410.655,-5.808 440.723,28.14 L704.777,325.37 C734.846,358.860 731.802,410.654 697.979,440.723 L400.956,704.777 C367.133,734.845 315.338,731.802 285.269,697.979 L21.216,400.955 C-8.852,367.132 -5.808,315.337 28.14,285.269 Z"
            />
          </svg>
        </div>
        <div className="shape-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="515px" height="515px">
            <defs>
              <linearGradient
                id="PSgrad_0"
                x1="0%"
                x2="89.879%"
                y1="0%"
                y2="43.837%"
              >
                <stop offset="0%" stopColor="rgb(67,186,255)" stopOpacity="1" />
                <stop
                  offset="100%"
                  stopColor="rgb(113,65,177)"
                  stopOpacity="1"
                />
              </linearGradient>
            </defs>
            <path
              fillRule="evenodd"
              fill="rgb(43, 142, 254)"
              d="M19.529,202.281 L230.531,14.699 C254.559,-6.660 291.353,-4.498 312.714,19.529 L500.295,230.531 C521.656,254.559 519.493,291.353 495.466,312.714 L284.463,500.295 C260.436,521.656 223.641,519.493 202.281,495.466 L14.699,284.463 C-6.660,260.435 -4.498,223.641 19.529,202.281 Z"
            />
            <path
              fill="url(#PSgrad_0)"
              d="M19.529,202.281 L230.531,14.699 C254.559,-6.660 291.353,-4.498 312.714,19.529 L500.295,230.531 C521.656,254.559 519.493,291.353 495.466,312.714 L284.463,500.295 C260.436,521.656 223.641,519.493 202.281,495.466 L14.699,284.463 C-6.660,260.435 -4.498,223.641 19.529,202.281 Z"
            />
          </svg>
        </div>
        <div className="shape-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="972.5px"
            height="970.5px"
          >
            <path
              fillRule="evenodd"
              stroke="rgb(255, 255, 255)"
              strokeWidth="1px"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              fill="none"
              d="M38.245,381.103 L435.258,28.158 C480.467,-12.32 549.697,-7.964 589.888,37.244 L942.832,434.257 C983.23,479.466 978.955,548.697 933.746,588.888 L536.733,941.832 C491.524,982.23 422.293,977.955 382.103,932.746 L29.158,535.733 C-11.32,490.524 -6.963,421.293 38.245,381.103 Z"
            />
          </svg>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* <!-- Hero Content Start --> */}
              <div className="hero-content">
                <h3
                  className="sub-title"
                  data-aos-delay="600"
                  data-aos="fade-up"
                >
                  Technology Releted Consultancy
                </h3>
                <h2 className="title" data-aos="fade-up" data-aos-delay="800">
                  We transform ideas into technology
                </h2>
                <p data-aos="fade-up" data-aos-delay="900">
                  Empowering artificial intelligence at our core, we drive
                  optimal outcomes for modern businesses.
                </p>
                <div
                  className="hero-btn d-flex gap-2"
                  data-aos="fade-up"
                  data-aos-delay="1000"
                >
                  {/* <Link className="btn" href="#">
                    Read More
                  </Link> */}
                  <a
                    className="btn"
                    href="/pdf/Acliss-Global.pdf"
                    target="blank"

                  >
                    Read More
                  </a>

                  <a
                    className="btn get-demo"
                    href="https://t.me/aclissglobal"
                    target="blank"

                  >
                    Get Demo
                  </a>
                </div>
              </div>
              {/* <!-- Hero Content End --> */}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Hero End --> */}

      {/* <!-- Service Start --> */}
      <div
        className="section techwix-service-section-03 section-03-image"
        style={{ backgroundImage: "url(/images/bg/service-bg3.jpg)" }}
      >
        <div className="container">
          {/* <!-- Service Wrap Start --> */}
          <div className="service-wrap-03">
            <div className="row">
              <div className="col-xl-3 col-md-6">
                {/* <!-- Service Item Start --> */}
                <div className="service-item-03">
                  <div className="service-img">
                    <img src="/images/ser-icon9.png" alt="" />
                  </div>
                  <div className="service-content">
                    <h3 className="title">
                      <Link to="/service">
                        AI & Automation Services
                      </Link>
                    </h3>
                    <ul>
                      <li>Chatbot Development.</li>
                      <li>Agentic AI.</li>
                      <li>Retrieval-Augmented Generation (RAG).</li>
                      <li>Sentiment Analysis.</li>
                      <li>AI-Based Recommendation Engines.</li>
                    </ul>

                    {/* <div className="read-more">
                      <Link href="/service">
                        <i className="fas fa-plus"></i> Read More
                      </Link>
                    </div> */}
                  </div>
                </div>
                {/* <!-- Service Item End --> */}
              </div>
              <div className="col-xl-3 col-md-6">
                {/* <!-- Service Item Start --> */}
                <div className="service-item-03">
                  <div className="service-img">
                    <img src="/images/ser-icon10.png" alt="" />
                  </div>
                  <div className="service-content">
                    <h3 className="title">
                      <Link to="/service">
                        Exchange & Trading Solutions
                      </Link>
                    </h3>
                    <ul>
                      <li>Centralized Exchange (CEX)</li>
                      <li>Decentralized Exchange (DEX)</li>
                      <li>Liquidity Bot & Market Maker Solutions</li>
                      <li>P2P Trading Platforms</li>
                      <li>P2P Trading Platforms</li>
                      <li>Buy/Sell Fiat Integration</li>
                      <li>Admin & Analytics Dashboards</li>
                    </ul>
                  </div>
                </div>
                {/* <!-- Service Item End --> */}
              </div>
              <div className="col-xl-3 col-md-6">
                {/* <!-- Service Item Start --> */}
                <div className="service-item-03">
                  <div className="service-img">
                    <img src="/images/ser-icon11.png" alt="" />
                  </div>
                  <div className="service-content">
                    <h3 className="title">
                      <Link to="/service">
                        Web3 & Blockchain Innovation
                      </Link>
                    </h3>
                    <ul>
                      <li>Web3 & dApp Solutions</li>
                      <li>Smart Contract Development</li>
                      <li>NFT Platforms & Interactive Digital Arts</li>
                      <li>Custom Token Creation (ERC-20, BEP-20, etc.)</li>
                      <li> Blockchain Layer Integration</li>
                    </ul>
                  </div>
                </div>
                {/* <!-- Service Item End --> */}
              </div>
              <div className="col-xl-3 col-md-6">
                {/* <!-- Service Item Start --> */}
                <div className="service-item-03">
                  <div className="service-img">
                    <img src="/images/ser-icon12.png" alt="" />
                  </div>
                  <div className="service-content">
                    <h3 className="title">
                      <Link to="/service">
                        Strategy, Consulting & Architecture
                      </Link>
                    </h3>
                    <ul>
                      <li>Blockchain Consulting & Architecture</li>
                      <li>Custom Product Development</li>
                      <li>Security & Compliance Integration</li>
                      <li>API Integrations & Third-Party Connectivity</li>
                      <li> Infrastructure & DevOps Setup</li>
                    </ul>
                  </div>
                </div>
                {/* <!-- Service Item End --> */}
              </div>
            </div>
          </div>
          {/* <!-- Service Wrap End --> */}
        </div>
      </div>
      {/* <!-- Service End --> */}


      {/* <!-- Choose Us Start --> */}
      <div
        className="section techwix-choose-us-section section-padding section_choose-us-section_image"
        style={{ backgroundImage: "url(/images/bg/choose-us-bg.jpg)" }}
      >
        <div className="container">
          {/* <!-- Choose Us Wrap Start --> */}
          <div className="choose-us-wrap">
            <div className="section-title text-center">
              <h3 className="sub-title">REASON TO CHOOSE US</h3>
              <h2 className="title">Our Core Strengths</h2>
            </div>
            <div className="choose-us-content-wrap">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item">
                    <div className="choose-us-img">
                      <Link to="/volume-boosting">
                        <img src="/images/choose-us-img.png" alt="" />
                      </Link>
                      <div className="choose-us-content">
                        {/* <h3 className="title">Liquidity Bot & Market Maker Solutions</h3> */}
                        {/* <p>
                          Our proprietary liquidity bots ensure your exchange or token remains liquid and tradeable across platforms. We build bots tailored for CEXs and DEXs, including arbitrage, spread control, and volume generation strategies.
                        </p> */}
                      </div>
                    </div>
                  </div>
                  {/* <!-- Choose here Us Item End --> */}
                </div>
                <div className="col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item">
                    <div className="choose-us-img">
                      <Link to="/interactive-digitalArt">
                        <img src="/images/interactiveDigitalArts.png" alt="" />
                      </Link>
                      <div className="choose-us-content">
                        {/* <h3 className="title">Interactive Digital Arts</h3> */}
                        {/* <p>
                          We create NFT marketplaces, minting portals, and custom token standards with support for ERC-721, ERC-1155, and beyond. Whether it's art, real estate, or gaming, we turn assets into secure, tradable NFTs.
                        </p> */}
                      </div>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item">
                    <div className="choose-us-img">
                      <Link to="/blockchain-consulting">
                        <img src="/images/blockchainConsulting.png" alt="" />
                      </Link>
                      <div className="choose-us-content">
                        {/* <h3 className="title">Blockchain Consulting & Architecture</h3> */}
                        {/* <p>
                          We guide clients from ideation to implementation—helping choose the right technology stack, design scalable architectures, and ensure long-term success. Our blockchain consultants have real-world project experience across Ethereum, Polygon, Solana, BNB Chain, and more.
                        </p> */}
                      </div>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item">
                    <div className="choose-us-img">
                      <Link to="/centralized-exchange-solutions">
                        <img src="/images/centralizedExchange.png" alt="" />
                      </Link>
                      <div className="choose-us-content">
                        {/* <h3 className="title">Centralized Exchange (CEX) Solutions</h3> */}
                        {/* <p>
                          We design and develop high-performance centralized exchanges with real-time order matching, secure wallet integrations, KYC/AML support, admin dashboards, and liquidity features. Our systems are built for 24/7 uptime and high-frequency trading.
                        </p> */}
                      </div>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item">
                    <div className="choose-us-img">
                      <Link to="/decentralized-exchange-solutions">
                        <img src="/images/decentralizedExchange.png" alt="" />
                      </Link>
                      <div className="choose-us-content">
                        {/* <h3 className="title">Decentralized Exchange (DEX) Solutions</h3> */}
                        {/* <p>
                          We build DEX platforms that are secure, fast, and fully decentralized, powered by smart contracts. With support for multi-chain protocols and automated liquidity pools, our DEX solutions enable seamless peer-to-peer trading.

                        </p> */}
                      </div>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item">
                    <div className="choose-us-img">
                      <Link to="/Web3-dApp-solutions">
                        <img src="/images/Web3DApp.png" alt="" />
                      </Link>
                      <div className="choose-us-content">
                        {/* <h3 className="title">Web3 & dApp Solutions</h3> */}
                        {/* <p>
                          We bring ideas to life on the decentralized web—be it through custom DApps, blockchain wallets, DAOs, or smart contract development. Our Web3 solutions focus on trustless interactions and user sovereignty.
                        </p> */}
                      </div>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <div className="more-choose-content text-center">
                    <p>
                      {/* Learn more about{" "} */}
                      {/* <Link href="/choose-us">
                        More reason{" "}
                        <i className="fas fa-long-arrow-alt-right"></i>
                      </Link>{" "} */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Choose Us Wrap End --> */}
        </div>
      </div>
      {/* <!-- Choose Us End --> */}

      <div className="section techwix-counter-section-02">
        <div className="container">
          <div className="counter-wrap">
            <div className="row">
              <div className="col-xl-3 col-md-6 p-0">
                {/* <!-- Single Counter Start --> */}
                <div className="single-counter">
                  <div className="counter-img">
                    <img src="/images/counter-1.png" alt="" />
                  </div>
                  <div className="counter-content">
                    <CountUp
                      end={50}
                      duration={2.5}
                      enableScrollSpy
                      scrollSpyDelay={200}
                    >
                      {({ countUpRef }) => (
                        <span className="counter" ref={countUpRef} />
                      )}
                    </CountUp>
                    {/* <span className="counter">1790</span> */}
                    <p>+ Happy clients</p>
                  </div>
                </div>
                {/* <!-- Single Counter End --> */}
              </div>
              <div className="col-xl-3 col-md-6 p-0">
                {/* <!-- Single Counter Start --> */}
                <div className="single-counter">
                  <div className="counter-img">
                    <img src="/images/counter-2.png" alt="" />
                  </div>
                  <div className="counter-content">
                    <CountUp
                      end={100}
                      duration={2.5}
                      enableScrollSpy
                      scrollSpyDelay={200}
                    >
                      {({ countUpRef }) => (
                        <span className="counter" ref={countUpRef} />
                      )}
                    </CountUp>
                    <span className="counter"></span>
                    <p>+ Finished projects</p>
                  </div>
                </div>
                {/* <!-- Single Counter End --> */}
              </div>
              <div className="col-xl-3 col-md-6 p-0">
                {/* <!-- Single Counter Start --> */}
                <div className="single-counter">
                  <div className="counter-img">
                    <img src="/images/counter-3.png" alt="" />
                  </div>
                  <div className="counter-content">
                    <CountUp
                      end={42}
                      duration={2.5}
                      enableScrollSpy
                      scrollSpyDelay={200}
                    >
                      {({ countUpRef }) => (
                        <span className="counter" ref={countUpRef} />
                      )}
                    </CountUp>
                    <span className="counter"></span>
                    <p>Skilled Experts</p>
                  </div>
                </div>
                {/* <!-- Single Counter End --> */}
              </div>
              <div className="col-xl-3 col-md-6 p-0">
                {/* <!-- Single Counter Start --> */}
                <div className="single-counter single-counter-4">
                  <div className="counter-img">
                    <img src="/images/counter-1.png" alt="" />
                  </div>
                  <div className="counter-content">
                    <CountUp
                      end={100}
                      duration={2.5}
                      enableScrollSpy
                      scrollSpyDelay={200}
                    >
                      {({ countUpRef }) => (
                        <span className="counter" ref={countUpRef} />
                      )}
                    </CountUp>
                    <span className="counter"></span>
                    <p>+ Media Posts</p>
                  </div>
                </div>
                {/* <!-- Single Counter End --> */}
              </div>
            </div>
          </div>
        </div>
        <br /><br /><br /><br />
      </div>

      {/* <!-- Skill Start --> */}
      <div className="section techwix-skill-section-02 section-padding">
        <div className="container">
          <div className="skill-wrap">
            <div className="row">
              <div className="col-lg-6">
                {/* <!-- Skill Left Start --> */}
                <div className="skill-left">
                  <div className="section-title">
                    <h2 className="title">
                      Preparing for your success, we provide truly prominent IT
                      solutions
                    </h2>
                  </div>
                  <div className="experience-wrap">
                    <div className="experience">
                      <h2 className="number">15</h2>
                      <span>
                        Years of experience
                      </span>
                    </div>
                    <div className="experience-text">
                      <p>
                        Empowering your success with cutting-edge IT solutions
                        for a brighter, efficient, and innovative future, built
                        on trust, expertise, and excellence — delivering
                        reliability, scalability, growth, and long-term digital
                        transformation.
                      </p>
                      {/* <Link className="learn-more" href="/about">
                        learn More About Us{" "}
                        <i className="fas fa-long-arrow-alt-right"></i>
                      </Link> */}
                    </div>
                  </div>
                </div>
                {/* <!-- Skill Left End --> */}
              </div>
              <div className="col-lg-6">
                {/* <!-- Skill Right Start --> */}
                <div className="skill-right">
                  <div className="counter-bar">
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">IT Managment</span>
                      <SkillBar title={80} percentage={80} />
                    </div>
                    {/* <!-- Skill Item End --> */}
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">Data Security</span>
                      <SkillBar title={95} percentage={95} />
                    </div>
                    {/* <!-- Skill Item End --> */}
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">Information Technology</span>
                      <SkillBar title={80} percentage={80} />
                    </div>
                    {/* <!-- Skill Item End --> */}
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">Technology Consultant</span>
                      <SkillBar title={90} percentage={90} />
                    </div>
                    {/* <!-- Skill Item End --> */}
                  </div>
                </div>
                {/* <!-- Skill Right End --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Case Study Start --> */}
      <div
        className="section techwix-case-study-section-02 section-padding case-study-section-02-image"
        style={{ backgroundImage: "url(/images/bg/case-study-bg.jpg)" }}
      >
        <div className="container">
          <div className="case-study-wrap">
            <div className="section-title text-center">
              <h2 className="title white mb-2">AI solutions, real impact</h2>
              <h3 className="sub-title">Transforming business workflows using scalable AI systems.</h3>
            </div>
          </div>
        </div>
        {/* <!-- Case Study Content Wrap Start --> */}
        <div className="case-study-content-wrap">
          <div className="swiper-container case-study-active">
            <Swiper
              // slidesPerView={3}
              // spaceBetween={30}
              centeredSlides={false}
              loop={true} // 👈 This enables infinite loop
              pagination={{ dynamicMainBullets: true }}
              modules={[Pagination]}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                991: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
            //   className="case-swiper"
            >
              {slides.map((slide, i) => (
                <SwiperSlide key={slide.id}>
                  <div className="swiper-slide">
                    {/* <!-- Single Case Study Start --> */}
                    <div className="single-case-study-02">
                      <div className="case-study-img">
                        <Link href="#">
                          <img src={slide.image} alt={`Slide ${i + 1}`} />
                        </Link>
                      </div>

                    </div>
                    {/* <!-- Single Case Study End --> */}
                  </div>
                  {/* <div className="slide-wrapper">
                    <img src={slide.image} alt={`Slide ${i + 1}`} />
                    <div className="slide-overlay">
                      <small>{slide.subtitle}</small>
                      <h3>{slide.title}</h3>
                      <p>{slide.description}</p>
                    </div>
                  </div> */}
                </SwiperSlide>
              ))}
            </Swiper>

            {/* <!-- Add Pagination --> */}
            {/* <div className="swiper-pagination"></div> */}
          </div>
        </div>
        {/* <!-- Case Study Content Wrap End --> */}
      </div>
      {/* <!-- Case Study End --> */}

      {/* <!-- Testimonial Start  --> */}
      <div className="section techwix-testimonial-section-02 techwix-testimonial-section-03 section-padding-02">
        {/* <Testimonial /> */}
      </div>
      {/* <!-- Testimonial End  --> */}

      {/* <!-- Brand Logo Start --> */}

      {/* <!-- Brand Logo End --> */}

      {/* <!-- Team Start --> */}

      {/* <!-- Team End --> */}

      {/* <!-- Blog Start --> */}

      {/* <!-- Blog End --> */}

      {/* <!-- Cta Start --> */}
      <div className="section techwix-cta-section-02">
        <div className="container">
          {/* <!-- Cta Wrap Start --> */}
          <div
            className="cta-wrap cta-wrap-image"
          >
            <div className="row align-items-center">
              <div className="col-xl-9 col-lg-8">
                {/* <!-- Cta Content Start --> */}
                <div className="cta-content">
                  <div className="cta-icon">
                    <img
                      src="/images/cta-icon2.png"
                      alt="image"
                      className="cta-image"
                    />
                  </div>
                  <p>We’re Delivering the best customer Experience</p>
                </div>
                {/* <!-- Cta Content End --> */}
              </div>
              <div className="col-xl-3 col-lg-4">
                {/* <!-- Cta Button Start --> */}
                <div className="cta-btn">
                  <Link className="btn btn-white" href="#">
                    +91 980 545 9192
                  </Link>
                </div>
                {/* <!-- Cta Button End --> */}
              </div>
            </div>
          </div>
          {/* <!-- Cta Wrap End --> */}
        </div>
      </div>
      {/* <!-- Cta End --> */}

      {/* <!-- Footer Section Start --> */}
      <Footer />
      {/* <!-- Footer Section End --> */}

      {/* <!-- back to top start --> */}
      <div className="progress-wrap">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
      {/* <!-- back to top end --> */}
    </div>
  );
}
